import { render, staticRenderFns } from "./CompanyWhitelabelForm.vue?vue&type=template&id=7427cf44&scoped=true&"
import script from "./CompanyWhitelabelForm.vue?vue&type=script&lang=js&"
export * from "./CompanyWhitelabelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7427cf44",
  null
  
)

export default component.exports